import { makeAutoObservable, runInAction } from 'mobx';
import MainStore from './mainStore';

export default class NotificationsStore {
	mainStore: MainStore;

	showError = false;
	errorMessage = '';

	showNotifications = false;
	notificationMessage = '';

	preloader = false;

	private errorTimer: ReturnType<typeof setTimeout> | null = null;
	private notificationTimer: ReturnType<typeof setTimeout> | null = null;

	constructor(mainStore: MainStore) {
		makeAutoObservable(this);

		this.mainStore = mainStore;
	}

	setError = (error: string) => {
		if (this.errorTimer) {
			clearTimeout(this.errorTimer);
		}

		runInAction(() => {
			this.showError = true;
			this.errorMessage = error;
		});

		this.errorTimer = setTimeout(() => {
			runInAction(() => {
				this.showError = false;
				this.errorMessage = '';
			});
			this.errorTimer = null;
		}, 3000);
	}

	setNotifications = (notifications: string) => {
		if (this.notificationTimer) {
			clearTimeout(this.notificationTimer);
		}

		runInAction(() => {
			this.showNotifications = true;
			this.notificationMessage = notifications;
		});

		this.notificationTimer = setTimeout(() => {
			runInAction(() => {
				this.showNotifications = false;
				this.notificationMessage = '';
			});
			this.notificationTimer = null;
		}, 3000);
	}

	showPreloader = () => {
		runInAction(() => {
			this.preloader = true;
		});
	}

	hidePreloader = () => {
		runInAction(() => {
			this.preloader = false;
		});
	}
}